import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { ProfileMin } from '../../../../profiles/shared/profile-min.model';
import { UtilService } from '../../../../shared/index';
import { EventRead } from '../../../shared/event-read.model';
import { RegistrationUpsert } from 'src/app/events-v4/shared/registration/crud/registration-upsert.model';
import { EventItemSummary } from 'src/app/events-v4/shared/items/event-item-summary.model';
import { RegistrationItemSponsor } from 'src/app/events-v4/shared/registration/registration-item-sponsor.model';
import { IValidationComponent } from '../../../../shared/widgets/component/ivalidation.component';
import { ValidationResult } from '../../../../shared/widgets/validators/validation-result.model';
import { TranslationService } from '../../../../shared/translation/translation.service';
import { ImageLookupComponent } from '../../../../config/image-lookup/image-lookup.component';
import { EventV4ItemService } from 'src/app/events-v4/shared/items/event-v4-item.service';
import { EventV4SponsorsService } from 'src/app/events-v4/shared/sponsors/event-v4-sponsors.service';

@Component({
  selector: 'wl-event-v4-registration-wizard-sponsor',
  templateUrl: 'event-v4-registration-wizard-sponsor.component.html',
  providers: [EventV4ItemService, EventV4SponsorsService],
    standalone: false
})
export class Eventv4RegistrationWizardSponsorComponent implements OnInit, IValidationComponent {
  @ViewChild('sponsorImageSelector', { static: false }) sponsorImageSelector: ImageLookupComponent;

  public registrationId: number;
  public registration: RegistrationUpsert = new RegistrationUpsert();
  public event: EventRead = new EventRead();
  public initialLoadComplete: boolean = false;

  public _utilService: UtilService;
  public _translationService: TranslationService;

  public _eventItemService: EventV4ItemService;
  public _eventSponsorService: EventV4SponsorsService;

  public sponsor: RegistrationItemSponsor;
  public availableItems: Array<EventItemSummary>;
  public itemTotal: number;

  public _invertedDoNotDisplay: boolean = true;

  public constructor(
    utilService: UtilService,
    eventItemService: EventV4ItemService,
    eventSponsorService: EventV4SponsorsService,
    translationService: TranslationService
  ) {
    this._utilService = utilService;
    this._eventItemService = eventItemService;
    this._eventSponsorService = eventSponsorService;
    this._translationService = translationService;

    this.sponsor = new RegistrationItemSponsor();
    this.availableItems = new Array<EventItemSummary>();

    this.itemTotal = 0;
    this.registrationId = 0;
  }

  ngOnInit() {}

  public loadData = (profile?: ProfileMin): void => {
    let eventId = this.event.EventId;

    if (this.registration.IsEdit == true) {
      for (let regItem of this.registration.Items) {
        if (regItem.IsSponsorShip == true) {
          if (this._utilService.isNotNullOrUndefined(regItem.Sponsor)) {
            if (this._utilService.isNotNullEmptyOrWhitespace(regItem.Sponsor.SponsorName)) {
              this.sponsor = regItem.Sponsor;
              break;
            }
          }
        }
      }
    }

    if (this.sponsor.SponserId <= 0) {
      // don't assume it should be created during edit
      if (this.registration.IsEdit) {
        this.sponsor.DoNotDisplay = true;
        this._invertedDoNotDisplay = false;
      }

      //set default sponsor info
      if (this._utilService.isNullEmptyOrWhitespace(this.sponsor.SponsorName)) {
        this.sponsor.SponsorName = this.registration.Registration.OrgName;
      }

      if (profile && profile.Website)
        this.sponsor.SponsorWebsite = /^https?:\/\//i.test(profile.Website.trim()) ? profile.Website : 'http://' + profile.Website;
      else this.sponsor.SponsorWebsite = '';
    }

    this.initialLoadComplete = true;
  };

  public getValidationResult = (): ValidationResult => {
    let valid = new ValidationResult();

    valid.isValid = true;

    return valid;
  };

  public setImageProfileIdFilter = (profileId: number): void => {
    this.sponsorImageSelector.setImageProfileIdFilter(profileId);
  };

  /**
   * triggered by checkbox change
   * @param display
   */
  public handleInvertedDoNotDisplayChange(display: boolean): void {
    console.error(display);
    if (this.sponsor) this.sponsor.DoNotDisplay = !display;
  }
}
